import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { genfunction } from 'helpers'

const useStyles = makeStyles(theme => ({

}));

const getSubTitle = (subTitle) => {
    return subTitle && subTitle != "" ?
        <Typography variant="subtitle1">
            {ReactHtmlParser(genfunction.replaceEscapeCharacters(subTitle))}
        </Typography>
        : ""
}

const Title = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.content}>
            <Typography variant="h1">
                {ReactHtmlParser(genfunction.replaceEscapeCharacters(props.Header))}
            </Typography>
            {getSubTitle(props.SubTitle)}
            {getSubTitle(props.SubTitle2)}
        </div>
    );
};

Title.propTypes = {
    Header: PropTypes.string,
    SubTitle: PropTypes.string,
    SubTitle2: PropTypes.string
};

export default Title;
